import React from 'react';

const TestimonialCard = ({ image, testimonial, name, location }) => {
  return (
    <article
      className="flex flex-col w-full bg-white border border-solid border-neutral-700 p-4 md:p-6 h-full"
      role="article"
      aria-labelledby="testimonial-author"
    >
      <div className="flex flex-col md:flex-row gap-4 md:gap-6 h-full">
        {/* Image Section */}
        <div className="flex justify-center md:justify-start items-start flex-shrink-0">
          <img
            src={image}
            alt={`Portrait of ${name}`}
            className="object-cover w-24 h-32 md:w-32 md:h-40 rounded-sm"
            loading="lazy"
          />
        </div>

        {/* Content Section */}
        <div className="flex flex-col justify-between flex-1">
          {/* Quote Icon */}
          <div className="flex justify-center md:justify-start mb-3">
            <svg
              width="40"
              height="40"
              viewBox="0 0 73 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-8 h-8 md:w-10 md:h-10"
              aria-hidden="true"
            >
              <path
                d="M11.3307 19.0909C10.6346 19.0909 10.0782 19.9688 10.0741 21.0591L10.0081 38.6804C10.0021 39.7707 10.5686 40.6562 11.2647 40.6485L23.1659 40.5165C24.2043 41.3059 22.7525 46.4131 18.9541 48.3807C15.7287 50.0514 18.8068 53.382 18.65 53.9468C23.9495 52.6472 25.9276 50.5956 27.2972 49.6075C29.4733 47.8302 32.8642 43.1882 33.7105 39.7337C33.835 39.4281 33.8014 39.0712 33.8029 38.6803L33.8689 21.0591C33.8749 19.9687 33.3084 19.0908 32.6122 19.0908L11.3307 19.0909Z"
                stroke="#404040"
                strokeWidth="1.10827"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M41.152 19.0909C40.4558 19.0909 39.8994 19.9688 39.8954 21.0591L39.8294 38.6804C39.8234 39.7707 40.3899 40.6562 41.0859 40.6485L52.9872 40.5165C54.0256 41.3059 52.5738 46.4131 48.7754 48.3807C45.55 50.0514 48.6281 53.382 48.4713 53.9468C53.7708 52.6472 55.7489 50.5956 57.1185 49.6075C59.2946 47.8302 62.6855 43.1882 63.5318 39.7337C63.6563 39.4281 63.6227 39.0712 63.6242 38.6803L63.6902 21.0591C63.6962 19.9687 63.1297 19.0908 62.4335 19.0908L41.152 19.0909Z"
                stroke="#404040"
                strokeWidth="1.10827"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* Testimonial Text */}
          <div className="flex-1 mb-4">
            <p className="text-xs md:text-sm font-medium leading-5 md:leading-6 text-center md:text-left text-neutral-700">
              {testimonial}
            </p>
          </div>

          {/* Name and Location */}
          <div className="flex flex-col items-center md:items-start space-y-1 mt-auto">
            <h3
              id="testimonial-author"
              className="text-sm md:text-base font-medium text-neutral-700"
            >
              {name}
            </h3>
            <span className="text-xs md:text-sm font-medium text-yellow-500">
              {location}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
};

export default TestimonialCard;
